import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { can } from '@/ability'
import { computed } from '@vue/composition-api'

const canReadAssets = computed(() => can.value(AbilityAction.Read, AbilitySubject.AssetGroups))
const canEditAsset = computed(() => can.value(AbilityAction.Edit, AbilitySubject.Asset))
const canDeleteAsset = computed(() => can.value(AbilityAction.Delete, AbilitySubject.Asset))
const canEditAssetGroups = computed(() => can.value(AbilityAction.Edit, AbilitySubject.AssetGroups))
const canDeleteAssetGroups = computed(() => can.value(AbilityAction.Delete, AbilitySubject.AssetGroups))
const canChangeAudio = computed(() => can.value(AbilityAction.Edit, AbilitySubject.Audio))
const canCreateCast = computed(() => can.value(AbilityAction.Create, AbilitySubject.Cast))
const canCreateCastTemplate = computed(() => can.value(AbilityAction.Create, AbilitySubject.CastTemplates))
const canCreateMembers = computed(() => can.value(AbilityAction.Create, AbilitySubject.Members))
const canCopyCast = computed(() => can.value(AbilityAction.Copy, AbilitySubject.Cast))
const canDeleteArchive = computed(() => can.value(AbilityAction.Delete, AbilitySubject.Archive))
const canDeleteCast = computed(() => can.value(AbilityAction.Delete, AbilitySubject.Cast))
const canDeleteMembers = computed(() => can.value(AbilityAction.Delete, AbilitySubject.Members))
const canDeleteTemplates = computed(() => can.value(AbilityAction.Delete, AbilitySubject.CastTemplates))
const canEditCast = computed(() => can.value(AbilityAction.Edit, AbilitySubject.Cast))
const canEditCasterStreams = computed(() => can.value(AbilityAction.Edit, AbilitySubject.CasterStream))
const canEditTemplates = computed(() => can.value(AbilityAction.Edit, AbilitySubject.CastTemplates))
const canReadArchive = computed(() => can.value(AbilityAction.Read, AbilitySubject.Archive))
const canReadCast = computed(() => can.value(AbilityAction.Read, AbilitySubject.Cast))
const canReadMembers = computed(() => can.value(AbilityAction.Read, AbilitySubject.Members))
const canReadTemplates = computed(() => can.value(AbilityAction.Read, AbilitySubject.CastTemplates))
const canDoOps = computed(() => can.value(AbilityAction.Do, AbilitySubject.Ops))
const canEditMembers = computed(() => can.value(AbilityAction.Edit, AbilitySubject.Members))
const canCreateTeamSettings = computed(() => can.value(AbilityAction.Create, AbilitySubject.TeamSettings))
const canDeleteTeamSettings = computed(() => can.value(AbilityAction.Delete, AbilitySubject.TeamSettings))
const canEditTeamSettings = computed(() => can.value(AbilityAction.Edit, AbilitySubject.TeamSettings))
const canReadTeamSettings = computed(() => can.value(AbilityAction.Read, AbilitySubject.TeamSettings))
const canNotifyCaster = computed(() => can.value(AbilityAction.Notify, AbilitySubject.Cast))
const canReadReport = computed(() => can.value(AbilityAction.Read, AbilitySubject.Report))
const canEditReport = computed(() => can.value(AbilityAction.Edit, AbilitySubject.Report))
const canCreateLayout = computed(() => can.value(AbilityAction.Create, AbilitySubject.Layout))
const canEditLayout = computed(() => can.value(AbilityAction.Edit, AbilitySubject.Layout))
const canDeleteLayout = computed(() => can.value(AbilityAction.Delete, AbilitySubject.Layout))
const canReadLayout = computed(() => can.value(AbilityAction.Read, AbilitySubject.Layout))
const canReadFtp = computed(() => can.value(AbilityAction.Read, AbilitySubject.Ftp))
const canReadStreamAuth = computed(() => can.value(AbilityAction.Read, AbilitySubject.StreamAuth))

const useCanDo = () => {
  return {
    canChangeAudio,
    canCopyCast,
    canCreateCast,
    canCreateCastTemplate,
    canCreateLayout,
    canCreateMembers,
    canCreateTeamSettings,
    canDeleteArchive,
    canDeleteAsset,
    canDeleteAssetGroups,
    canDeleteCast,
    canDeleteLayout,
    canDeleteMembers,
    canDeleteTeamSettings,
    canDeleteTemplates,
    canDoOps,
    canEditAsset,
    canEditAssetGroups,
    canEditCast,
    canEditCasterStreams,
    canEditLayout,
    canEditMembers,
    canEditReport,
    canEditTeamSettings,
    canEditTemplates,
    canReadArchive,
    canReadAssets,
    canReadCast,
    canReadFtp,
    canReadReport,
    canReadLayout,
    canReadMembers,
    canReadStreamAuth,
    canReadTemplates,
    canReadTeamSettings,
    canNotifyCaster
  }
}

export default useCanDo
